import styled from 'styled-components';
import { TShirtSizing } from '@theme/theme';
import { pxToRem } from '@theme/utils/sizing';
import { colors } from '@theme/globals/colors';

export const CloseButton = styled.button<{
  buttonBackgroundColor: string;
  buttonIsFilled: boolean;
  buttonSize: TShirtSizing;
}>`
  background-color: ${(props): string => {
    if (!props.buttonIsFilled) {
      return 'transparent';
    }
    if (colors[props.buttonBackgroundColor]) {
      return colors[props.buttonBackgroundColor] as string;
    }
    return props.buttonBackgroundColor;
  }};
  align-content: center;
  align-items: center;
  border-radius: 50%;
  border: none;
  display: flex;
  justify-content: center;
  opacity: 0.5;
  padding: ${pxToRem(4)} ${pxToRem(4.3)};
  transition: opacity 0.2s;
  &:hover {
    opacity: 1;
    cursor: pointer;
  }
`;
